var map = {
	"./afternoonTea/1.png": 8748,
	"./afternoonTea/2.png": 3925,
	"./afternoonTea/3.png": 2950,
	"./afternoonTea/4.png": 7445,
	"./birthday/1.png": 2601,
	"./birthday/2.png": 671,
	"./birthday/3.png": 1818,
	"./club/1.png": 4975,
	"./club/2.png": 4315,
	"./club/3.png": 9186,
	"./club/4.png": 1557,
	"./festival/1.png": 875,
	"./festival/2.png": 6907,
	"./festival/3.png": 5895,
	"./festival/4.png": 4755,
	"./festival/5.png": 7265,
	"./life/1.png": 2773,
	"./tourism/1.png": 3313,
	"./tourism/2.png": 8621,
	"./tourism/3.png": 8814,
	"./tourism/4.png": 5711,
	"./tourism/5.png": 8321,
	"./tourism/6.png": 2419,
	"./tourism/7.png": 7436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;